export const SET_ORDER = 'SET_ORDER';
export const CLEAR_ORDER = 'CLEAR_ORDER';
export const SET_MEAN_TIME = 'SET_MEAN_TIME';
export const SET_ACTIVE_ORDER_NOW = 'SET_ACTIVE_ORDER_NOW';
export const SET_ACTIVE_ORDER_BEFORE = 'SET_ACTIVE_ORDER_BEFORE';
export const SET_ORDER_ITEM = 'SET_ORDER_ITEM';

export function setOrderNow(orders) {
    return{
        type: SET_ACTIVE_ORDER_NOW,
        payload: orders
    }
}

export function setOrderBefore(orders) {
    return{
        type: SET_ACTIVE_ORDER_BEFORE,
        payload: orders
    }
}

export function setOrder(order) {
    return{
        type: SET_ORDER,
        payload: order
    }
}

export function setOrderItem(order) {
    return{
        type: SET_ORDER_ITEM,
        payload: order
    }
}

export function clearOrder() {
    return{
        type: CLEAR_ORDER,
    }
}
export function setMeanTime(time) {
    return{
        type: SET_MEAN_TIME,
        payload: time
    }
}

